import { useTranslation } from "react-i18next";

import { faCheckCircle, faInfoCircle, faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { TooltipHover } from "src/components";
import { Icon, Tooltip } from "src/components-v2";
import { TableProps } from "src/components-v2/Table";
import { TableStyled } from "./index.styled";

import { REQUIRED_DOCUMENTS_DATA, REQUIRED_DOCUMENTS_TABLE_HEADERS } from "./const";

export default function TableDocs(props: TableProps) {
  const { t } = useTranslation("getting-started-page");

  return (
    <TableStyled {...props}>
      <thead>
        <tr>
          {REQUIRED_DOCUMENTS_TABLE_HEADERS.map((item) => (
            <th key={`headers_${item.dataKey}`}>
              <span>{t(`needed-documents.table-headers.${item.dataKey}`)}</span>
              {item.tooltip && (
                <Tooltip.Wrapper className="u-inline-block">
                  <TooltipHover>
                    <Icon icon={faInfoCircle} className="u-ml-1" />
                    <Tooltip position="top">{t(`needed-documents.table-headers.${item.tooltip}`)}</Tooltip>
                  </TooltipHover>
                </Tooltip.Wrapper>
              )}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {REQUIRED_DOCUMENTS_DATA.map((data, i) => (
          <tr key={i}>
            {Object.values(data).map((value, key) => {
              const isBoolean = typeof value === "boolean";
              const isArray = Array.isArray(value);

              const IconComp = (
                <Icon
                  icon={value ? faCheckCircle : faTimesCircle}
                  className={value ? "u-text-jade" : "u-text-ketchup-tomato"}
                />
              );

              const ListComp = isArray && (
                <ol>
                  {value.map((key) => (
                    <li key={key}>
                      <span>{t(`needed-documents.needed-documents-data.${key}`)}</span>
                    </li>
                  ))}
                </ol>
              );

              return (
                <td key={key}>
                  {isBoolean ? IconComp : isArray ? ListComp : t(`needed-documents.needed-documents-data.${value}`)}
                </td>
              );
            })}
          </tr>
        ))}
      </tbody>
    </TableStyled>
  );
}
